import React from 'react';
import {
  IIsrcMetadataConflictDetails,
  IValidationResults,
} from '@/data/models/validation';
import {
  formatIsrcMetadataConflictSourceLabel,
  getIsrcMetadataConflictDetails,
} from '@/utils/isrcMetadataConflictFormatting';
import './IsrcMetadataConflictDetails.scss';

function formatValue(value?: string | null): string {
  return value ?? '""';
}

export function getIsrcMetadataConflictErrors(
  errors: IValidationResults[]
): IValidationResults[] {
  return errors.filter(
    (error) => getIsrcMetadataConflictDetails(error) !== null
  );
}

interface Props {
  errors: IValidationResults[];
  fallbackCatalogUpc?: string | null;
}

export default function IsrcMetadataConflictDetails({
  errors,
  fallbackCatalogUpc,
}: Props) {
  const conflicts = errors
    .map((error) => getIsrcMetadataConflictDetails(error))
    .filter((details): details is IIsrcMetadataConflictDetails => !!details);

  if (conflicts.length === 0) {
    return null;
  }

  return (
    <div className="isrc-metadata-conflicts">
      {conflicts.map((details, index) => (
        <div
          className="isrc-metadata-conflicts__item"
          key={`${details.isrc}-${details.source}-${index}`}
        >
          <div className="isrc-metadata-conflicts__summary">
            <strong>ISRC:</strong> {details.isrc}
          </div>
          <ul className="isrc-metadata-conflicts__list">
            {details.mismatches.map((mismatch, mismatchIndex) => (
              <li key={`${mismatch.field}-${mismatchIndex}`}>
                <div className="isrc-metadata-conflicts__field">
                  {mismatch.field} -{' '}
                  <span className="isrc-metadata-conflicts__source">PRS:</span>{' '}
                  {formatValue(mismatch.currentValue)} /{' '}
                  <span className="isrc-metadata-conflicts__source">
                    {formatIsrcMetadataConflictSourceLabel(
                      details,
                      fallbackCatalogUpc
                    )}
                    :
                  </span>{' '}
                  {formatValue(mismatch.otherValue)}
                </div>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
}
